/* eslint-disable node/no-unsupported-features/es-syntax */
import { SHIFT_ROUTE_NAMES } from "@/shared";
export const SHIFT_ROUTES = [
    {
        name: SHIFT_ROUTE_NAMES.MAIN,
        path: "/shift",
        meta: {
            title: "words.all_shifts_header",
        },
        component: () => import("../ui/ShiftsPage.vue"),
    },
];
